/* @flow */

import {useMutation} from '@apollo/react-hooks';

import type {
    CreateAccountFromMcfxCompany as CreateAccountFromMcfxCompanyMutation,
    CreateAccountFromMcfxCompanyVariables as CreateAccountFromMcfxCompanyMutationVariables,
    CreateAccountFromMcfxCompanyInput,
} from 'nutshell-graphql-types';

import CREATE_ACCOUNT_FROM_MCFX_COMPANY from '../mutations/create-account-from-mcfx-company.graphql';

export function useCreateAccountFromMcfxCompany(): (CreateAccountFromMcfxCompanyInput) => Promise<
    *
> {
    const [createCompany] = useMutation<
        CreateAccountFromMcfxCompanyMutation,
        CreateAccountFromMcfxCompanyMutationVariables
    >(CREATE_ACCOUNT_FROM_MCFX_COMPANY);

    return (input: CreateAccountFromMcfxCompanyInput) => {
        return createCompany({
            variables: {input},
        });
    };
}
